import { constants } from '@bingads-webui/instrumentation';
import { Filter } from '@bingads-webui/listener';
import type { InstrumentationLog } from '../types';

export class LogLevelFilter extends Filter {
  check(logMessage: InstrumentationLog) {
    const appLogLevel = constants.LOGLEVEL.INFO;

    if (logMessage.logLevel) {
      return (logMessage.logLevel as { value: number }).value > appLogLevel.value;
    }

    return false;
  }
}
